import React from 'react';
import { setCurrentView } from 'core/utils';
import { ChangeShippingViewStore } from 'modules/order/stores';
import { ChangeShippingTemplate } from 'themes/modules/order/pages';

@setCurrentView(
	(rootStore, componentProps) => new ChangeShippingViewStore(rootStore, componentProps),
	'changeShippingViewStore'
)
class ChangeShipping extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ChangeShippingTemplate {...this.props} />;
	}
}

export default ChangeShipping;



// WEBPACK FOOTER //
// ./src/modules/order/pages/ChangeShipping.jsx